import React, { useState } from 'react';
import { Box, TextField, Button, Typography, InputAdornment, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HrmsImage from '../../assets/Hrms.png';
import axios from 'axios';
import { axiosInstance, localAxios, localAxiosPut } from '../../Axios/axios';
import Loader from '../../components/Loader';
import { Visibility, VisibilityOff } from '@mui/icons-material';


const ForgotPasswordPage = () => {
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otpInput, setOtpInput] = useState('')
  const [verifyOTPDone, setVerifyOTPDone] = useState(false);
  const [emailGenerateOtp, setEmailGenerateOtp] = useState(true);
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('')
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showVerifyOtpError, setShowVerifyOtpError] = useState(false);
  const [showVerifyOtpMessage, setShowVerifyOtpMessage] = useState('');
  const [changePasswordError, setChangePasswordError] = useState('');
  const [generateOtpError, setGenerateOtpError] = useState('');


  const handleGenerateOtp = async () => {
    setIsLoading(true);
    setGenerateOtpError(''); 

    
    if (!email || !email.includes('@') || !email.includes('.')) {
        setGenerateOtpError("Please enter a valid email address.");
        setIsLoading(false);
        return;
    }

    try {
        const response = await axiosInstance(localAxios('/organization/generateOtp', { email: email }));
        console.log('Generated OTP Response:', response.data);
        setIsOtpGenerated(true); 
        setVerifyOTPDone(false); 
        setEmailGenerateOtp(false); 
        // 
    } catch (error) {
        console.log("OTP Generation Error:", error.response ? error.response.data : error.message);

        if (error.response) {
            console.log('Error Data:', error.response.data);
            console.log('Error Status:', error.response.status);

            
            if (error.response.status === 404 && error.response.data.message === "User not found") {
                setGenerateOtpError("User not found with this email address. Please check and try again.");
            }
            
            else if (error.response.data && error.response.data.message) {
               
                setGenerateOtpError(error.response.data.message);
            } else {
                
                setGenerateOtpError(`An unexpected server error occurred (Status: ${error.response.status}).`);
            }
        } else if (error.request) {
           
            console.log('Error Request:', error.request);
            setGenerateOtpError("Network error: No response from the server. Please check your internet connection.");
        } else {
           
            console.log('Error Message:', error.message);
            setGenerateOtpError(`Error: ${error.message}. Please try again.`);
        }
    } finally {
        setIsLoading(false); 
    }
};

  const handleVerifyOTPButton = async () => {
    setIsLoading(true)
    console.log('otp', otpInput);
    try {
      const response = await axiosInstance(localAxios('/organization/verifyOtp', { email: email, otp: otpInput }));
      console.log("Verify OTP Response:", response.data);
      setVerifyOTPDone(true); 
      setIsOtpGenerated(false);
      setEmailGenerateOtp(false);

    } catch (error) {
      console.log("Verify OTP Error:", error.response ? error.response.data : error.message);

      if (error.response && error.response.data) {

        if (error.response.status === 400) {
          setShowVerifyOtpError(true);
         
          setShowVerifyOtpMessage(error.response.data.message || "An unexpected error occurred.");
        } else {
         
          setShowVerifyOtpError(true);
          setShowVerifyOtpMessage(error.response.data.message || "An error occurred during OTP verification.");
        }
      } else {
        
        setShowVerifyOtpError(true);
        setShowVerifyOtpMessage("Network error or server is unreachable. Please try again.");
      }
      setVerifyOTPDone(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePassword = async () => {
    setIsLoading(true);
    setChangePasswordError(''); 

   const data = {
        email: email,
        newPassword: newPassword,
        confirmPassword: confirmPassword
    };
    console.log('password data', data);

    
    if (newPassword !== confirmPassword) {
        setChangePasswordError("New password and confirm password do not match.");
        setIsLoading(false);
        return;
    }
    if (newPassword.length < 6) { 
        setChangePasswordError("Password must be at least 6 characters long.");
        setIsLoading(false);
        return;
    }


    try {       
       
        const response = await axiosInstance(localAxiosPut('/organization/updatePassword', data));      
        navigate('/login');

    } catch (error) {
        console.log('Change Password Error object:', error); 

        if (error.response) {
            
            console.log('Error Data:', error.response.data);
            console.log('Error Status:', error.response.status);

           
            if (error.response.data && error.response.data.message) {
                setChangePasswordError(error.response.data.message);
            } else if (error.response.status === 400) {
                setChangePasswordError("Bad Request: Please check your input fields.");
            } else {
               
                setChangePasswordError(`Server error (${error.response.status}): ${error.response.statusText || 'An unexpected error occurred.'}`);
            }
        } else if (error.request) {
           
            setChangePasswordError("Network error: No response from server. Please check your internet connection.");
        } else {
          
            setChangePasswordError(`Request setup error: ${error.message}`);
        }}finally {
          setIsLoading(false); 
      }
    }

return (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      height: '100vh',
      width: '100vw',
      backgroundColor: 'rgba(41, 41, 41, 1)',
    }}
  >
    {isLoading && <Loader />}
    <Box
      sx={{
        flex: 1,
        backgroundImage: `url(${HrmsImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    ></Box>


    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: { xs: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', md: '60%' },
          maxWidth: '350px',
        }}
      >

        {isOtpGenerated && (

          <Box sx={{ mt: 2 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 'bold',
                mb: 2,
                color: '#ffffff',
                textAlign: 'center',
              }}
            >
              Forgot Password?
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 3,
                color: '#bbbbbb',
                textAlign: 'center',
              }}
            >
              Please enter your email address below, and we will send you an OTP
              to your registered email.
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter OTP"
              variant="outlined"
              size="small"
              value={otpInput} 
              onChange={(e) => setOtpInput(e.target.value)} 
              sx={{
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                mb: 2,
              }}
              InputProps={{
                style: { color: '#000000' },
              }}
            />
            {showVerifyOtpError && (
              <Typography sx={{ mb: 1, color: 'red' }}>{showVerifyOtpMessage}</Typography>
            )}
            <Button
              fullWidth
              variant="contained"
              onClick={handleVerifyOTPButton} 
              sx={{
                backgroundColor: '#1a237e',
                color: '#fff',
                padding: '10px',
                fontWeight: 'bold',
                fontSize: '0.9rem',
                '&:hover': {
                  backgroundColor: '#0d47a1',
                },
              }}
            >
              Verify OTP
            </Button>
          </Box>

        )}


        <>

          <form>
            {emailGenerateOtp && (
              <>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: '#ffffff',
                    textAlign: 'center',
                  }}
                >
                  Forgot Password?
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 3,
                    color: '#bbbbbb',
                    textAlign: 'center',
                  }}
                >
                  Please enter your email address below, and we will send you an OTP
                  to your registered email.
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Enter email address"
                  variant="outlined"
                  size="small"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{
                    backgroundColor: '#ffffff',
                    borderRadius: '4px',
                    mb: 2,
                  }}
                  InputProps={{
                    style: { color: '#000000' },
                  }}
                />
                 {generateOtpError && (
                        <Typography
                            color="error"
                            sx={{
                                mt: 2,
                                mb: 2,
                                textAlign: 'center',
                                backgroundColor: 'rgba(255, 0, 0, 0.1)',
                                padding: '8px',
                                borderRadius: '4px'
                            }}
                        >
                            {generateOtpError}
                        </Typography>
                    )}
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleGenerateOtp}
                  sx={{
                    backgroundColor: '#1a237e',
                    color: '#fff',
                    padding: '10px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    '&:hover': {
                      backgroundColor: '#0d47a1',
                    },
                  }}
                >
                  Generate OTP
                </Button>
              </>
            )}
            {verifyOTPDone && (
              <>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: '#ffffff',
                    textAlign: 'center',
                  }}
                >
                  Forgot Password?
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 3,
                    color: '#bbbbbb',
                    textAlign: 'center',
                  }}
                >
                  Please create a new password to log in to your account.
                </Typography>
                <form>
                  <TextField
                    fullWidth
                    placeholder="Enter email address"
                    variant="outlined"
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '4px',
                      mb: 2,
                    }}
                    InputProps={{
                      style: { color: '#000000' },
                    }}
                  />
                  <TextField
                    fullWidth
                    placeholder="Create new password"
                    variant="outlined"
                    size="small"
                    type={showPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '4px',
                      mb: 2,
                    }}
                    InputProps={{
                      style: { color: '#000000' },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    fullWidth
                    placeholder="Confirm new password"
                    variant="outlined"
                    size="small"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    sx={{
                      backgroundColor: '#ffffff',
                      borderRadius: '4px',
                      mb: 2,
                    }}
                    InputProps={{
                      style: { color: '#000000' },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            edge="end"
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {changePasswordError && (
                    <Typography color="error" sx={{ mt: 2, mb: 2 }}>
                      {changePasswordError}
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleChangePassword}
                    sx={{
                      backgroundColor: '#1a237e',
                      color: '#fff',
                      padding: '10px',
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                      '&:hover': {
                        backgroundColor: '#0d47a1',
                      },
                    }}
                  >
                    Change Password
                  </Button>
                </form>
              </>
            )}

          </form>
        </>


      </Box>
    </Box>
  </Box>
);
};

export default ForgotPasswordPage;
